import { ChatTypes } from "~proto"
import type { RootStore } from "~models/root-store/root-store"

export function parseUserId(raw: unknown): number | null {
  if (raw == null || raw === "") return null
  const id = typeof raw === "number" ? raw : Number(String(raw).trim())
  return Number.isFinite(id) && id > 0 ? id : null
}

/** 仅允许查看本人、通讯录好友、或已有会话/群成员关系用户的资料 */
export function canViewUserProfile(userId: number, root: RootStore): boolean {
  const { userStore, contactStore, friendStore, chatStore } = root
  const currentUserId = userStore.currentUser?.id
  if (!currentUserId || !userId) return false
  if (userId === currentUserId) return true
  if (contactStore.byUserId(userId)) return true
  if (friendStore.friendsByUserId(userId)) return true
  if (chatStore.getPrivateChatByUserID(userId)) return true

  for (const chat of chatStore.chats.values()) {
    if (![ChatTypes.GROUP, ChatTypes.GROUP_MINE, ChatTypes.GROUP_DRAGON].includes(chat.type)) {
      continue
    }
    if (chat.members?.some((m) => m.user_id === userId)) {
      return true
    }
  }
  return false
}
